import "../css/style.scss"

// Our modules / classes
import MobileMenu from "./modules/MobileMenu"
import HeroSlider from "./modules/HeroSlider"
import GoogleMap from "./modules/GoogleMap"  
import SearchNoJQuery from "./modules/SearchNoJQuery"
import NotesNoJQuery from "./modules/NotesNoJQuery"
import Like from "./modules/Like"

// Instantiate a new object using our modules/classes
const mobileMenu = new MobileMenu()
const heroSlider = new HeroSlider()
const googleMap = new GoogleMap()
const search = new SearchNoJQuery()
const notes = new NotesNoJQuery()
const likes = new Like()